import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row gy-5 gx-xl-8" }
const _hoisted_2 = {
  class: "col-xxl-4",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_3 = {
  class: "col-xxl-4",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_4 = {
  class: "col-xxl-4",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_5 = {
  class: "col-xxl-6",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_6 = {
  class: "col-xxl-6",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_7 = {
  key: 0,
  class: "row gy-5 gx-xl-8 align-items-start"
}
const _hoisted_8 = {
  class: "col-xxl-6",
  style: {"height":"100%"}
}
const _hoisted_9 = {
  class: "col-xxl-6",
  style: {"height":"100%"}
}
const _hoisted_10 = {
  class: "col-xxl-6",
  style: {"height":"100%"}
}
const _hoisted_11 = {
  class: "col-xxl-6",
  style: {"height":"100%"}
}
const _hoisted_12 = {
  key: 1,
  class: "row gy-5 gx-xl-8"
}
const _hoisted_13 = {
  class: "col-xxl-6",
  style: {"height":"100%"}
}
const _hoisted_14 = {
  class: "col-xxl-6",
  style: {"height":"100%"}
}
const _hoisted_15 = {
  key: 2,
  class: "col-xxl-12"
}
const _hoisted_16 = {
  key: 3,
  class: "col-xxl-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisteredAccountsWidget = _resolveComponent("RegisteredAccountsWidget")!
  const _component_BrokersAccountsWidget = _resolveComponent("BrokersAccountsWidget")!
  const _component_MarketeersAccountsWidget = _resolveComponent("MarketeersAccountsWidget")!
  const _component_AuctionsSummaryWidget = _resolveComponent("AuctionsSummaryWidget")!
  const _component_TradesSummaryWidget = _resolveComponent("TradesSummaryWidget")!
  const _component_SubscriptionsWidget = _resolveComponent("SubscriptionsWidget")!
  const _component_BrokersAdsPackagesWidget = _resolveComponent("BrokersAdsPackagesWidget")!
  const _component_MapPackgesWidget = _resolveComponent("MapPackgesWidget")!
  const _component_AdsSummeryWidget = _resolveComponent("AdsSummeryWidget")!
  const _component_IveStatsWidget = _resolveComponent("IveStatsWidget")!
  const _component_IreStatsWidget = _resolveComponent("IreStatsWidget")!
  const _component_OthersSummaryWidget = _resolveComponent("OthersSummaryWidget")!
  const _component_AdsTypesSummaryWidget = _resolveComponent("AdsTypesSummaryWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RegisteredAccountsWidget, {
          "widget-classes": "card-xxl-stretch mb-xl-8",
          "chart-color": "primary",
          "chart-height": "200"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BrokersAccountsWidget, {
          "widget-classes": "card-xxl-stretch mb-xl-8",
          "chart-color": "primary",
          "chart-height": "200"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_MarketeersAccountsWidget, {
          "widget-classes": "card-xxl-stretch mb-xl-8",
          "chart-color": "primary",
          "chart-height": "200"
        })
      ]),
      (_ctx.showGroup2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AuctionsSummaryWidget, {
                "widget-classes": "card-xxl-stretch mb-xl-8",
                "chart-color": "primary",
                "chart-height": "50"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_TradesSummaryWidget, {
                "widget-classes": "card-xxl-stretch mb-xl-8",
                "chart-color": "primary",
                "chart-height": "50"
              })
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showGroup3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SubscriptionsWidget, {
              "widget-classes": "card-xxl-stretch mb-xl-8",
              "chart-color": "primary",
              "chart-height": "200"
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_BrokersAdsPackagesWidget, {
              "widget-classes": "card-xxl-stretch mb-xl-8",
              "chart-color": "primary",
              "chart-height": "200"
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_MapPackgesWidget, {
              "widget-classes": "card-xxl-stretch mb-xl-8",
              "chart-color": "primary",
              "chart-height": "200"
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_AdsSummeryWidget, {
              "widget-classes": "card-xxl-stretch mb-xl-8",
              "chart-color": "primary",
              "chart-height": "200"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGroup4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_IveStatsWidget, { "widget-classes": "card-xxl-stretch mb-xl-8" })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_IreStatsWidget, { "widget-classes": "card-xxl-stretch mb-xl-8" })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGroup5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_OthersSummaryWidget, {
            "widget-classes": "card-xxl-stretch mb-xl-8",
            "chart-color": "warning",
            "chart-height": "200"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showGroup6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_AdsTypesSummaryWidget, {
            "widget-classes": "card-xxl-stretch mb-xl-8",
            "chart-color": "info",
            "chart-height": "200"
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}